var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExamIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_241_632)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 15.9991H11.4678V3.76673H0V15.9991ZM10.5857 4.70768V15.0581H0.882141V4.70768H10.5857ZM15 0V12.2333H12.3536V11.2914H14.1179V0.94095H4.41434V2.82283H3.53131V0H15ZM2.64641 8.47442H8.82139V7.53347H2.64641V8.47442H2.64641ZM2.64641 12.2333H8.82139V11.2914H2.64641V12.2333H2.64641ZM2.64641 10.3534H7.05712V9.41242H2.64641V10.3534H2.64641Z",
    fill: "#92CCCA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_241_632"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamIcon);
export default __webpack_public_path__ + "static/media/exam-icon.fbd2ac57b88e97d03e67b33fdc238e78.svg";
export { ForwardRef as ReactComponent };